import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

export enum ColorScheme {
  Dark = 'dark',
  Light = 'light',
}

export enum ColorSchemePreference {
  Dark = 'dark',
  Light = 'light',
  Auto = 'auto',
}

export const defaultColorScheme = ColorScheme.Light;

@Injectable({
  providedIn: 'root',
})
export class ColorSchemeService {
  private colorScheme: ColorScheme = defaultColorScheme;
  private colorSchemeAttrName = 'color-scheme';
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  init() {
    this._getColorScheme();
    this.renderer.setAttribute(
      document.firstElementChild,
      this.colorSchemeAttrName,
      this.colorScheme,
    );
  }

  _detectPreferredColorScheme() {
    if (window.matchMedia('(prefers-color-scheme)').media !== 'not all') {
      this.colorScheme = window.matchMedia('(prefers-color-scheme: dark)')
        .matches
        ? ColorScheme.Dark
        : ColorScheme.Light;
    } else {
      this.colorScheme = ColorScheme.Light;
    }
  }

  _getPreferredColorScheme() {
    let preferredColorScheme = ColorScheme.Light;
    if (window.matchMedia('(prefers-color-scheme)').media !== 'not all') {
      preferredColorScheme = window.matchMedia('(prefers-color-scheme: dark)')
        .matches
        ? ColorScheme.Dark
        : ColorScheme.Light;
    } else {
      preferredColorScheme = ColorScheme.Light;
    }
    return preferredColorScheme;
  }
  _setColorScheme(scheme: ColorScheme) {
    this.colorScheme = scheme;
    localStorage.setItem('scheme', scheme);
  }

  _getColorScheme() {
    const localStorageColorScheme = localStorage.getItem('scheme');
    if (localStorageColorScheme) {
      this.colorScheme = localStorageColorScheme as ColorScheme;
    } else {
      // start with dark colors
      this.colorScheme = ColorScheme.Dark;
    }
  }

  set(scheme: ColorScheme): void;
  set(scheme: ColorSchemePreference): void;
  set(scheme: ColorScheme | ColorSchemePreference): void {
    const colorScheme =
      scheme === ColorSchemePreference.Auto
        ? this._getPreferredColorScheme()
        : (scheme as unknown as ColorScheme);

    this._setColorScheme(colorScheme);

    this.renderer.setAttribute(
      document.firstElementChild,
      this.colorSchemeAttrName,
      colorScheme,
    );
  }

  get(): ColorScheme {
    return this.colorScheme;
  }
}
